import React, { useState, useEffect,useRef } from 'react'
import style from './index.module.scss'
function Index({onFinish}) {
    // 模拟
    const [seconds, setSeconds] = useState(30)
    const [videoLoad, setVideoLoad] = useState(false)
    let myVideo = useRef(null);

    const handleLoaderData = () =>{
        console.log(myVideo,'myVideo');
        if (myVideo.current) {
            setVideoLoad(true)
        }
    }
	const handleCanPlay = () =>{
        if (myVideo.current) {
            myVideo.current.play();
        }
    }
    const handlePlay = () =>{
        if (myVideo.current) {
            myVideo.current.muted = false; // 取消静音
            //if(!videoLoad){
            //    myVideo.current.play();
            //}
        }
    }
    useEffect(() => {
    // 启动定时器
    const timer = setInterval(() => {
        if (seconds >0) {
            setSeconds((prevTimer) => prevTimer - 1);
        }else{
            setSeconds(0)
            clearInterval(timer);
            onFinish()
        }
      }, 1000);
  
      // 在组件卸载或 effect 依赖改变时清除定时器
      return () => clearInterval(timer);
    }, [seconds])
    // return (
    //     <div className={style.ad}>
    //         {seconds}s
    //     <img src="https://boweisou.oss-cn-shenzhen.aliyuncs.com/community/loadingpage.gif" alt="" />
    //     </div>
    // )

    useEffect(() => {
        if (myVideo.current && !videoLoad) {
            myVideo.current.load();
        }

        // 全局声明只需运行一次
        window.TencentGDT = window.TencentGDT || [];
        let placement_id = '1134573798697024',app_id = '1210623212'

        // 广告示例声明
        window.TencentGDT.push({
            placement_id, // 广告位 ID
            app_id, // 应用 ID
            type: 'native',
            count: 1, // 拉取广告的数量
            onComplete: function (res) {
                console.log( res);
                if (res && res.constructor === Array) {
                    // 原生模板广告位调用 window.TencentGDT.NATIVE.renderAd(res[0], 'containerId') 进行模板广告的渲染
                    // res[0] 代表取广告数组第一个数据
                    // containerId：广告容器ID
                    window.TencentGDT.NATIVE.renderAd(res[0], 'containerId')
                } else {
                    // 加载广告API，如广告回调无广告，可使用loadAd再次拉取广告
                    // 注意：拉取广告频率每分钟不要超过20次，否则会被广告接口过滤，影响广告位填充率
                    setTimeout(function() {
                        window.TencentGDT.NATIVE.loadAd(placement_id)
                    }, 5000)
                }
            },
        });

        // 动态加载 SDK 脚本
        const loadSDK = () => {
            const doc = document;
            const b = doc.getElementsByTagName('body')[0];
            const s = doc.createElement('script');
            s.async = true;
            s.src = 'https://qzs.gdtimg.com/union/res/union_sdk/page/h5_sdk/i.js';
            b && b.appendChild(s);
        };

        // 确保 SDK 只加载一次
        if (!window.TencentGDT.__loaded) {
            loadSDK();
            window.TencentGDT.__loaded = true; // 标记 SDK 已加载
        }

        // 组件卸载时清理
        return () => {
            // 可以根据需要清理广告资源
        };
    }, []);

    return (
        <div className={style.ad}>
            <div className={style.close}> {seconds}s后自动关闭
                {/*<img src={require('../../../../image/close3.png')} alt=""/>*/}
            </div>
            <video src={require('../../../../static/index.mp4')} muted playsInline ref={myVideo} onLoadedData={()=>handleLoaderData()} onClick={() => handlePlay()} onCanPlayThrough={()=>handleCanPlay()}>
                <source src={require('../../../../static/index.mp4')} type="video/mp4" />
            </video>
            <div id="containerId" className={style.containerId}></div>
        </div>
    );
}

export default Index
